export interface CountryDialCode {
  name: string
  dialCode: string
}

export const COUNTRY_DIAL_CODES: CountryDialCode[] = [
  { name: 'España', dialCode: '+34' },
  { name: 'Andorra', dialCode: '+376' },
  { name: 'Portugal', dialCode: '+351' },
  { name: 'Francia', dialCode: '+33' },
  { name: 'Italia', dialCode: '+39' },
  { name: 'Reino Unido', dialCode: '+44' },
  { name: 'Alemania', dialCode: '+49' },
  { name: 'México', dialCode: '+52' },
  { name: 'Argentina', dialCode: '+54' },
  { name: 'Colombia', dialCode: '+57' },
  { name: 'Chile', dialCode: '+56' },
  { name: 'Perú', dialCode: '+51' },
  { name: 'Estados Unidos', dialCode: '+1' }
]
